import React from "react";
import { Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const MilestoneProperties = ({
  startDate,
  targetDate,
  handleStartdate,
  handleTargetdate,
  epicData,
  isEditable,
  children,
}) => {
  return (
    <Grid container className="sidebar-block">
      <Grid item className="sidebar-heading">
        <div className="sidebar-heading-content"></div>
      </Grid>
      <Grid item className="sidebar-details">
        <Grid item className="sidebar-details-content">
          <Grid item className="sidebar-worklog">
            <div className="sidebar-worklog-detail">Details</div>
          </Grid>
          <div className="box">
            <Grid item className="allocated-hours">
              <p>Start Date</p>
              <div className="taskdetail-sidebar-right-col">
                <DatePicker
                  className="edit-milestone-date-picker"
                  maxDate={targetDate ? targetDate : dayjs("2100-01-01")}
                  disabled={!isEditable}
                  value={startDate}
                  onChange={handleStartdate}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: "outlined",
                      placeholder: "MM/DD/YYYY",
                    },
                  }}
                />
              </div>
            </Grid>
          </div>
          <div className="box">
            <Grid item className="allocated-hours">
              <p>Target Date</p>
              <div className="taskdetail-sidebar-right-col">
                <DatePicker
                  className="edit-milestone-date-picker"
                  minDate={startDate ? startDate : dayjs("1900-01-01")}
                  disabled={!isEditable}
                  value={targetDate}
                  onChange={handleTargetdate}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: "outlined",
                      placeholder: "MM/DD/YYYY",
                    },
                  }}
                />
              </div>
            </Grid>
          </div>
          <div className="box">
            <Grid item className="allocated-hours">
              <p>Total Tasks</p>
              <div className="taskdetail-sidebar-right-col">
                <div className="allocated-hours-input">
                  <p className="due-date-input-allocate-hour-none">
                    {epicData?.card_count}
                  </p>
                </div>
              </div>
            </Grid>
          </div>
          <div className="box">
            <Grid item className="allocated-hours">
              <p>Allocated Hours</p>
              <div className="taskdetail-sidebar-right-col">
                <div className="allocated-hours-input">
                  <p className="due-date-input-allocate-hour-none">
                    {epicData?.total_allocated_hours}
                  </p>
                </div>
              </div>
            </Grid>
          </div>
          <div className="box">
            <Grid item className="allocated-hours">
              <p>Hours Spent</p>
              <div className="taskdetail-sidebar-right-col">
                <div className="allocated-hours-input">
                  <p className="due-date-input-allocate-hour-none">
                    {epicData?.total_hours_spent}
                  </p>
                </div>
              </div>
            </Grid>
          </div>
          <div className="box">
            <Grid item className="allocated-hours">
              <p>Hours Remaining</p>
              <div className="taskdetail-sidebar-right-col">
                <div className="allocated-hours-input">
                  <p className="due-date-input-allocate-hour-none">
                    {epicData?.total_remaining_hours}
                  </p>
                </div>
              </div>
            </Grid>
          </div>
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MilestoneProperties;
